/* Allure domain (allure-image.com) and dev/preview environments.
   Front door is the Allure photographer site.

   The Lumetier marketing landing remains reachable at /lumetier so any
   internal cross-links from the Allure site (or older share links) keep
   working. */

import { Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Booking from "@/pages/Booking";
import BookingConfirmation from "@/pages/BookingConfirmation";
import Contact from "@/pages/Contact";
import LumetierLanding from "@/pages/lumetier/Landing";
import LumetierOnboard from "@/pages/lumetier/Onboard";
import LumetierPreview from "@/pages/LumetierPreview";
import LumetierGalleriesPage from "@/pages/lumetier/products/Galleries";
import LumetierWebsitePage from "@/pages/lumetier/products/Website";
import LumetierManagerPage from "@/pages/lumetier/products/Manager";
import LumetierStorePage from "@/pages/lumetier/products/Store";
import { TenantProvider } from "@/lib/tenant";
import TenantTemplateShell from "@/templates/TenantTemplateShell";
import { renderSharedRoutes } from "@/routes/sharedRoutes";

export default function AllureAppRoutes() {
  return (
    <Routes>
      {/* Allure photographer site (front door) */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/booking/confirmation/:reference" element={<BookingConfirmation />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      {/* Per-tenant public site — template-aware. Reads
          site_settings.template_id and renders the matching template
          bundle (Editorial today; Minimal/Bold/Journal coming online
          as they're built). Same data flow, completely different
          looks per tenant. */}
      <Route path="/s/:slug/*" element={
        <TenantProvider><TenantTemplateShell /></TenantProvider>
      } />

      {/* Lumetier surface — still reachable via deep link from Allure */}
      <Route path="/lumetier" element={<LumetierLanding />} />
      <Route path="/lumetier-preview" element={<LumetierPreview />} />
      <Route path="/lumetier/onboard" element={<LumetierOnboard />} />
      <Route path="/lumetier/industries" element={<Navigate to="/lumetier" replace />} />

      {/* Lumetier product deep-dive pages (reachable from any nav dropdown) */}
      <Route path="/lumetier/galleries" element={<LumetierGalleriesPage />} />
      <Route path="/lumetier/website" element={<LumetierWebsitePage />} />
      <Route path="/lumetier/manager" element={<LumetierManagerPage />} />
      <Route path="/lumetier/store" element={<LumetierStorePage />} />

      {/* Legacy redirects */}
      <Route path="/atelier" element={<LumetierLanding />} />
      <Route path="/atelier-preview" element={<LumetierPreview />} />
      <Route path="/atelier/industries" element={<Navigate to="/lumetier" replace />} />

      {/* Shared product surfaces (admin, public gallery, signing, reviews) */}
      {renderSharedRoutes()}
    </Routes>
  );
}
